import React from "react";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

/**
 * The one row renderer for a folded header action (ISP-4018 phone header fold).
 *
 * Every secondary header entry (Feedback · Capture · Messages · Following ·
 * Invite) renders as an icon in the bar above the phone cut and as one of these
 * labeled rows below it. Keeping the row markup in ONE place means a new entry
 * cannot ship with a differently-shaped menu row, and the a11y contract (44px
 * row, accessible name, Enter/Space via MenuItem's native button semantics) is
 * stated once instead of five times.
 *
 * `...rest` is forwarded because MUI's MenuList clones its children to inject
 * roving-tabindex/autoFocus props; swallowing them here would break keyboard
 * navigation of the menu.
 */
export const NavEntryMenuItem = ({
  label,
  ariaLabel,
  icon,
  onActivate,
  closeMenu,
  ...rest
}) => (
  <MenuItem
    aria-label={ariaLabel || label}
    onClick={(e) => {
      // Activate BEFORE closing: ChatNavEntry hands the clicked element to the
      // dock store as a positioning anchor, so it must still be mounted.
      if (onActivate) onActivate(e);
      if (closeMenu) closeMenu();
    }}
    sx={{ minHeight: 44, gap: "4px" }}
    {...rest}
  >
    {icon ? <ListItemIcon sx={{ minWidth: 32 }}>{icon}</ListItemIcon> : null}
    <ListItemText
      primaryTypographyProps={{
        fontFamily: '"DM Sans", sans-serif',
        fontSize: 14,
      }}
    >
      {label}
    </ListItemText>
  </MenuItem>
);

export default NavEntryMenuItem;
